export const defaultStyle = {
    titleSize: 32,
    headingSpacing: 240,
    paragraphSpacing: 240,
    lineSpacing: 1.15,
    // Default font sizes
    heading1Size: 32,
    heading2Size: 28,
    heading3Size: 24,
    heading4Size: 20,
    heading5Size: 18,
    paragraphSize: 24,
    listItemSize: 24,
    codeBlockSize: 20,
    blockquoteSize: 24,
    // Default alignments
    paragraphAlignment: "LEFT",
    heading1Alignment: "LEFT",
    heading2Alignment: "LEFT",
    heading3Alignment: "LEFT",
    heading4Alignment: "LEFT",
    heading5Alignment: "LEFT",
    blockquoteAlignment: "LEFT",
    headingAlignment: "LEFT",
};
export const headingConfigs = {
    1: { level: 1, size: 0, style: "Title" },
    2: { level: 2, size: 0, style: "Heading2" },
    3: { level: 3, size: 0 },
    4: { level: 4, size: 0 },
    5: { level: 5, size: 0 },
};
